import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../App";

export default function OfflineUser({ user }) {

  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div className="accordion-header chatListname" id="headingTwo">
        <div className="d-flex">
          <div className="containerOnline">
            <img
              src={user?.image ==null || user?.image == 'null' ? 'https://d35vkepp4dfq5y.cloudfront.net/demo/demo_user.png': imageCdnUrl + user?.image }
              className=" SidebarStarListImage"
              alt=""
            />
          </div>

          <div className="col-md-9  mt-2">
            <Link to={`/starprofile/${user.id}`} className="text-light">
              <div className="chatName">
                {user?.first_name} {user?.last_name}
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
